import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LabelPrimaryText: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID,
    text
}) => (
    <p className={`${styles.labelPrimaryText} ${className}`} data-testid={testId}>
        {children || text}
    </p>
);

export default LabelPrimaryText;
